export const commonCameraRatios = ["1:1", "4:3", "16:9"];
